/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function List(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'List',
      'aria-hidden': true,
      focusable: false,
      width:  11 * scale,
      height: 11 * scale,
      viewBox: '0 0 11 11',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M0 0h2v2H0zm0 4h2v2H0zm4-4h7v2H4zm0 4h7v2H4zM0 8h2v2H0zm4 0h7v2H4z","fill":"currentColor","fillRule":"evenodd"}))
}
